import RentalNew from '@src/components/orbitalTrack/rentalSetting/common/RentalNew'
import RentalSettingDialog, {
  RentalType
} from '@src/components/orbitalTrack/rentalSetting/common/RentalSettingDialog'
import { useOrbitalTrackAttachContext } from '@src/contexts/orbitalTrack/OrbitalTrackAttachContext'
import { FC, useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

const PublicRentalNew: FC = () => {
  const { t } = useTranslation()

  const { refetchStar } = useOrbitalTrackAttachContext()

  // const { setOpen } = useOrbitalTrackRentalSettingContext()
  const [open, setOpen] = useState<boolean>(false)

  const handleOnClick = useCallback(() => {
    setOpen(true)
  }, [setOpen])

  const handleOnClose = useCallback(
    (success: boolean) => {
      setOpen(false)
      if (success) {
        refetchStar()
      }
    },
    [refetchStar]
  )

  return (
    <RentalNew
      title={t('godiverse.orbital_track.public_track')}
      description={t('godiverse.orbital_track.about_public_track')}
      buttonText={t('godiverse.orbital_track.new_public')}
      dialog={
        <RentalSettingDialog
          rentalType={RentalType.PUBLIC}
          open={open}
          onClose={handleOnClose}
        />
      }
      onNewClick={handleOnClick}
      variant='public'
    />
  )
}

export default PublicRentalNew
